import React, { FC } from 'react';
import * as styles from './styles';

const AnswerContainer: FC = ({ children }) => (
  <div className={styles.answerContainer} aria-label="subject answer container">
    {children}
  </div>
);

export default AnswerContainer;
